import React from 'react';
import { SvgIcon } from '@mui/material';
import colors from '../../../scss/colors'; // adjust the path as needed

function AddGradientIcon({ size = '24px' }) {
  return (
    <SvgIcon width={size} height={size} sx={{ fontSize: size }} viewBox="0 0 20 20">
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15
      11H11V15H9V11H5V9H9V5H11V9H15V11Z"
        fill={`url(#paint0_linear_735_126)`}
      />
      <defs>
        <linearGradient id="paint0_linear_735_126" x1="10" y1="0" x2="10" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.LIGHT_BLUE} stopOpacity="1" />
          <stop offset="1" stopColor={colors.LIGHT_BLUE} />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}

export default AddGradientIcon;
